<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <j-form-container >
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label="language['portal.unitCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="portalOrgCode">
                <a-input v-model="model.portalOrgCode" :placeholder="language['common.pleaseInput']+language['portal.unitCode']" :maxLength="ml_code" :disabled="disableSubmit"></a-input><!-- maxLength=50 -->
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['portal.unitName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="portalOrgName">
                <a-input v-model="model.portalOrgName" :placeholder="language['common.pleaseInput']+language['portal.unitName']" :maxLength="ml_name" style="width: 85%" :disabled="disableSubmit"></a-input>
                <a-button @click="languageModelOpen('SysPortalOrg','portalOrgName',portalOrgNameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="this.language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imgPath">
                <j-image-upload v-model="model.imgPath" :disabled="disableSubmit"></j-image-upload>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['portal.unitDesc']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="portalOrgDesc">
                <a-textarea v-model="model.portalOrgDesc" :placeholder="language['common.pleaseInput']+language['portal.unitDesc']" :maxLength="ml_desc" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['portal.unitStatus']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
                <j-dict-select-tag type="radio" v-model="model.status" :trigger-change="true" dictCode="sys_portal_up_down" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="language['portal.unitSortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
                <a-input-number v-model="model.sortNo" :placeholder="language['common.pleaseInput']+language['portal.unitSortNo']" style="width: 100%" :min="1" :max="999999" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-form-model-item :label="language['portal.unitApp']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="selectedApps">
                <j-multi-select-tag
                  v-model="model.selectedApps"
                  :options="appsOptions"
                  :disabled="disableSubmit"
                  :placeholder="language['common.pleaseChoose']+language['portal.unitApp']">
                </j-multi-select-tag>
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
                <a-textarea :placeholder="language['common.pleaseInput']+language['basedata.remark']" v-model="model.remark" :maxLength="ml" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </j-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import LanguageModel from "@/components/LanguageModel"

  export default {
    name: 'SysPortalOrgModal',
    components: {
      LanguageModel
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        model:{},
        ml:1000,
        ml_code:50,
        ml_name:100,
        ml_desc:255,
        appsOptions:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/sys/portal/sysPortalOrg/add",
          edit: "/sys/portal/sysPortalOrg/edit",
          queryById: "/sys/portal/sysPortalOrg/queryById",
          doDuplicateCheck:"/sys/portal/sysPortalOrg/doDuplicateCheck",
        },
        portalOrgNameLanguages:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        return {
          portalOrgCode: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['portal.unitCode'] + '!'},
            {validator: this.validateOrgCode,}
          ],
          portalOrgName: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['portal.unitName'] + '!'},
            {validator: this.validateOrgName,}
          ],
          portalOrgDesc: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['portal.unitDesc'] + '!'},
          ],
          status: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['portal.unitStatus'] + '!'},
          ],
          selectedApps: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['portal.unitApp'] + '!'},
          ],
        }
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.initAppList();
    },
    methods: {
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist,this.disableSubmit);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'portalOrgName'){
          this.portalOrgNameLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.portalOrgNameLanguages = res.result;
          }
        })
      },
      add () {
        this.visible = true;
        this.edit(this.modelDefault);
      },
      edit (record) {
        let that = this;
        this.model = Object.assign({},{selectedApps:''}, record);
        this.visible = true;
        if(record.hasOwnProperty("id")){
          that.getPortalApps(record.id);
          this.initLanguagetemp('SysPortalOrg','portalOrgName',record.id)
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                this.portalOrgNameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.portalOrgNameLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.submitCallback();
                    that.confirmLoading = false;
                  }
                })
              }else{
                that.$message.warning(res.message);
                that.confirmLoading = false;
              }
            })
          }

        })
      },

      validateOrgCode(rule, value, callback){
        console.log("this.model.id==============:",this.model.id)
        let params = {
          portalOrgCode: value,
          id:this.model.id
        };
        getAction(this.url.doDuplicateCheck,params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(this.language['portal.unitCode']+this.language['common.alreadyExists']+"!")
          }
        })
      },
      validateOrgName(rule, value, callback){
        console.log("this.model.id==============:",this.model.id)
        let params = {
          portalOrgName: value,
          id:this.model.id

        };
        getAction(this.url.doDuplicateCheck,params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(this.language['portal.unitName']+this.language['common.alreadyExists']+"!")
          }
        })
      },

      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllApps").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
            console.log('this.appsOptions: ',this.appsOptions)
          }
        })
      },

      getPortalApps(portalOrgId){
        getAction("/sys/portal/sysPortalOrg/getPortalApps",{id:portalOrgId}).then((res)=>{
          if(res.success){
            this.model.selectedApps = res.result.join(",");
            console.log('that.model.selectedApps=',this.model.selectedApps)
          }
        })
      },

      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }

    }
  }
</script>